import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueResource from 'vue-resource'
// import common, { user_msg } from '@/static/js/common.js';
// Vue.prototype.$base = common;
Vue.use(VueResource)
Vue.config.productionTip = false
Vue.prototype.$token = '';
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
